import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { removeOverlay } from '../../../../../firebase/hooks/useOverlays'
import { PollsListComponent } from '..'

import './PollsContainerComponent.scss'

const PollsContainerComponent = (props) => {
  const {
    renderPollUnitWrapper,
    styles,
    accentColor,
    iconColor,
    onCreateEditSubmit,
    polls,
    deletePoll,
    editPollsIds,
    toggleEditPoll,
    activatePoll,
    activePoll,
    canChangePoll,
    isVotingAllowed,
    answerPoll,
    answeredPollIds,
    togglePollOverlay,
    disableOverlayTrigger,
  } = props

  const onDeletePoll = (pollId) => {
    removeOverlay()
    deletePoll(pollId)
  }

  return (
    <div className="polls-component">
      <PollsListComponent
        polls={polls}
        styles={styles}
        toggleEditPoll={toggleEditPoll}
        deletePoll={onDeletePoll}
        editPollsIds={editPollsIds}
        renderPollUnitWrapper={renderPollUnitWrapper}
        accentColor={accentColor}
        iconColor={iconColor}
        onCreateEditSubmit={onCreateEditSubmit}
        activePoll={activePoll}
        activatePoll={activatePoll}
        canChangePoll={canChangePoll}
        isVotingAllowed={isVotingAllowed}
        answerPoll={answerPoll}
        answeredPollIds={answeredPollIds}
        togglePollOverlay={togglePollOverlay}
        disableOverlayTrigger={disableOverlayTrigger}
      />
    </div>
  )
}

PollsContainerComponent.propTypes = {
  polls: PropTypes.arrayOf(PropTypes.object),
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  isPublicPollOnly: PropTypes.bool,
  isVotingAllowed: PropTypes.bool,
  canCreateNewPoll: PropTypes.bool,
  canChangePoll: PropTypes.bool,
  renderPollUnitWrapper: PropTypes.func,
  deletePoll: PropTypes.func,
  onCreateEditSubmit: PropTypes.func,
  iconColor: PropTypes.string,
  accentColor: PropTypes.string,
  editPollsIds: PropTypes.object, // Set()
  toggleEditPoll: PropTypes.func,
  activatePoll: PropTypes.func,
  togglePollOverlay: PropTypes.func,
  styles: PropTypes.shape({
    inputStyle: PropTypes.object,
    secondaryButtonStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    progressBarStyles: PropTypes.object,
    radioButtonStyles: PropTypes.object,
  }),
  activePoll: PropTypes.object,
  answerPoll: PropTypes.func,
  answeredPollIds: PropTypes.object, // Set()
  disableOverlayTrigger: PropTypes.bool,
}

PollsContainerComponent.defaultProps = {
  isPublicPollOnly: false,
  canCreateNewPoll: false,
  canChangePoll: false,
}

const mapStateToProps = (state, ownProps) => ({
  activePoll: ownProps.selectors.getActivePoll(state),
})

export default connect(mapStateToProps)(PollsContainerComponent)
